<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title"> Quản lý sửa chữa - bảo hành - bảo trì</div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="list-title">
            <span class="p-m-0">Danh sách sửa chữa - bảo hành - bảo trì</span>
            <span class="p-input-icon-left" v-if="$myConstants.checkRoleGroup('warranty_repair', 'add')">
              <Button
              :label="'Tạo phiếu tiếp nhận'"
                type="button"
                v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo phiếu tiếp nhận'}, key: 'add'})"
              > </Button>
            </span>
          </div>
          <BaseCommon v-if="dataModel"
            :classDatatable="'list_warranty_repair'"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            v-on:action-click="onActionClicked"
            :actions="getRowActions()"
            @filterExport="filterExport"
          ></BaseCommon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
//import BaseCommon from '../common'
import BaseCommon from './core_list';
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      data_filter_export:null
    }
  },
  mounted () {
    this.initData();
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('warranty_repair', 'list')) {
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {
     /* this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);*/
      if(this.$route.params != undefined && this.$route.params != null && this.$route.params.phone_number != undefined && this.$route.params.phone_number != '') {
        this.filters['receive_user_info'] = this.$route.params.phone_number;
      }
      this.modelName = 'warranty_repair';
      /*var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var id_organization_hong_ky =await this.$coreService.id_organization_hong_ky();
      var whereKey = {
        status: {'_in': [0, 1] }
      };
      //Phân quyền dữ liệu
      var is_management_units = false;
      if (parseFloat(id_organization_hong_ky) ==  creator_organization_id){
        if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
          if (this.$store.getters.fullname.is_management_units == true){
            is_management_units = true;
          }
        }
      }
      if (is_management_units == false){
        whereKey.creator_organization_id = {'_eq': creator_organization_id};
      }
      var variables = {
        where_key: whereKey,
        orderBy: [
          {process_status: 'asc'},
          {id: 'desc'}
        ]
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];*/
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData([]);
      this.listData = [];
      this.componentKey++;
      //this.$store.commit('setLoading', false);
    },
    onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          if(this.checkVisible('warranty_repair', 'add')) {
            this.$router.push({path: '/admin/warranty-repair/function'});
          }
          break;
        case 'edit':
          if(this.checkVisible('warranty_repair', 'edit')) {
            if (data && Object.keys(data).length) {
              this.$router.push({path: '/admin/warranty-repair/function/' + data.data.id});
            }
          }
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        //if(that.checkVisible('warranty_repair', 'view')) {
        if(that.$myConstants.checkRoleGroup('warranty_repair', 'edit')) {
          buttons.edit = { name: 'edit', text: 'Xem', isText: true,  key: 'id', path: `admin/warranty-repair/edit`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
    },
    async filterExport(e){
      //console.log("EEE",e)
      this.data_filter_export = e
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.list_warranty_repair{
  .late_delivery_return_appointment_day{
    color: #CC0000;
  }
}
</style>